import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './modules/home/home.component';
import { AuthGuard } from './guards/auth.guard';
import { SaldoInicialComponent } from './modules/saldo-inicial/saldo-inicial.component';
import { NgModule } from '@angular/core';
import { EmpresaComponent } from './modules/empresa/empresa.component';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./auth/auth-routing.module').then((mod) => mod.AuthRoutingModule),
  },

  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
  },

  {
    path: '',
    loadChildren: () =>
      import('./modules/nfse/emissao/emissao-routing.module').then(
        (mod) => mod.NfseEmissaoRoutingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/extrato-bancario/extrato-bancario-routing.module').then(
        (mod) => mod.ExtratoRoutingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/lancamento-caixa/lancamento-caixa-routing.module').then(
        (mod) => mod.LancamentoCaixaRoutingModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'clientes',
    loadChildren: () =>
      import('./modules/clientes/clientes.module').then(
        (m) => m.ClientesModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'socios',
    loadChildren: () =>
      import('./modules/socios/socios-routing.module').then(
        (m) => m.SociosRoutingModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'descricao-padrao',
    loadChildren: () =>
      import('./modules/descricao-padrao/descricao-padrao.module').then(
        (m) => m.DescricaoPadraoModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'conta-bancaria',
    loadChildren: () =>
      import('./modules/conta-bancaria/conta-bancaria.module').then(
        (m) => m.ContaBancariaModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'receitas-brutas-anteriores',
    loadChildren: () =>
      import('./modules/receitas-brutas-anteriores/receitas-brutas-anteriores.module').then(
        (m) => m.ReceitasBrutasAnterioresModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules//declaracoes-fiscais/delcaracoes-fiscais.routing.module').then(
        (m) => m.DeclaracoesFiscaisRoutingModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'plano-de-contas',
    loadChildren: () =>
      import('./modules/plano-de-contas/plano-de-contas-routing.module').then(
        (mod) => mod.PlanoDeContasRoutingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'faturamento',
    loadChildren: () =>
      import('./modules/faturamento/faturamento-routing.module').then(
        (mod) => mod.FaturamentoRoutingModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'razao',
    loadChildren: () =>
      import('./modules/razao/razao-routing.module').then(
        (mod) => mod.RazaoRoutingModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'dre',
    loadChildren: () =>
      import('./modules/dre/dre-routing.module').then(
        (mod) => mod.DreRoutingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'empresa',
    loadChildren: () =>
      import('./modules/empresa/empresa-routing.module').then(
        (mod) => mod.EmpresaRoutingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'balanco-patrimonial',
    loadChildren: () =>
      import('./modules/balanco-patrimonial/balanco-patrimonial-routing.module').then(
        (mod) => mod.BalancoPatrimonialRoutingModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'balancete',
    loadChildren: () =>
      import('./modules/balancete/balancete-routing.module').then(
        (mod) => mod.BalanceteRoutingModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'folha-pagamentos',
    loadChildren: () =>
      import('./modules/folha-pagamentos/folha-pagamentos-routing.module').then(
        (mod) => mod.FolhaPagamentosRoutingModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'saldo-inicial',
    component: SaldoInicialComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'importacao-nfse-emitidas',
    loadChildren: () =>
      import('./modules/nfse/Importacao-nfse-emitidas/importacao-nfse-emitidas-routing.module').then(
        (mod) => mod.ImportacaoNfseEmitidasRoutingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'listagem-nfs-e',
    loadChildren: () =>
      import('./modules/nfse/listagem-nfse/nfse.module').then(
        (m) => m.NfesModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dividendos',
    loadChildren: () =>
      import('./modules/dividendos/dividendos-routing.module').then(
        (m) => m.DividendosRoutingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'tributos',
    loadChildren: () =>
      import('./modules/tributos/tributos-routing.module').then(
        (m) => m.TributosRoutingModule
      ),
    canActivate: [AuthGuard],
  },
];